export const GET_CHAMPIONS = "GET_CHAMPIONS";
export const FILTER_CHAMPIONS = "FILTER_CHAMPIONS";
export const ADD_CHAMPION = "ADD_CHAMPION";
export const EDIT_CHAMPION = "EDIT_CHAMPION";
export const GET_CHAMPION = "GET_CHAMPION";
export const RESET_CHAMPION = "RESET_CHAMPION";
export const CHAMPIONS_ERROR = "CHAMPIONS_ERROR";
